angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:companyOid/reviews", {
        templateUrl: 'assets/reviews/index.html',
        controller: 'ReviewsController',
        title: 'reviews.TITLE',
        sidebar: 'reviews'
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/reviews_route.js
// module id = 819
// module chunks = 3